import { DashboardHelper } from './../dashboard.service';
import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { List } from 'immutable';
import { EmailManagerModel } from '../../models/email-manager.model';
import { EmailManagerService } from '../email-manager.service';
import { EmailModelDTO } from '../../models/email-manager.model.dto';
import { AlertService } from '../alert.service';
import { BaseDataStore } from './base-data.store';
import { map } from 'rxjs/operators';
import { PermissionService } from '../permission.service';
import * as PermissionConstants from '../../modules/catch-core/data/constants/permission.constants';
@Injectable({
  providedIn: 'root',
})
export class EmailManagerStore extends BaseDataStore {
  private _emailManagers: BehaviorSubject<List<EmailManagerModel>> = new BehaviorSubject(List<EmailManagerModel>([]));

  public $emailManagers: Observable<List<EmailManagerModel>> = this._emailManagers.asObservable();

  constructor(
    private emailManagerService: EmailManagerService,
    private alertService: AlertService,
    private dashboardHelper: DashboardHelper,
    private permissionService: PermissionService,
  ) {
    super();
    //this.loadInitialData();
    this.behaviorSubjectList.push(this._emailManagers);
  }

  get $firstEmailManager(): Observable<EmailManagerModel | null> {
    return this.$emailManagers.pipe(
      map((emailManagers: List<EmailManagerModel>) => {
        if (emailManagers.count() > 0) {
          const emailManager = emailManagers.get(0);
          return emailManager;
        } else {
          return null;
        }
      }),
    );
  }

  public loadInitialData(): void {
    if (this.subscribers.emailManagerSubscription) {
      this.subscribers.emailManagerSubscription.unsubscribe();
    }

    if (!this.permissionService.hasPermission(PermissionConstants.EMAIL_MANAGER_READ)) {
      // Non-admin roles don't hold email_manager:read, so GET api/emailmanagers would 403 -
      // see api/docs/permissions/permission-v3.md.
      this._emailManagers.next(List([]));
      this.dashboardHelper.initCount += 1;
      return;
    }

    this.subscribers.emailManagerSubscription = this.emailManagerService.getEmailManagers().subscribe({
      next: (res: any) => {
        const emailManagers = (<Object[]>res).map((emailManager: any) => new EmailManagerModel(emailManager));

        this._emailManagers.next(List(emailManagers));
      },
      error: (err: any) => {
        // RxJS never fires `complete` after `error` - increment here too, otherwise a failed
        // request leaves dashboardHelper.initCount permanently short and the app-init loading
        // dialog never closes (see ui-state.store.ts's initCount >= 9 gate).
        console.log(err);
        this.alertService.showError('Error retrieving EmailManagers!');
        this.dashboardHelper.initCount += 1;
      },
      complete: () => {
        this.dashboardHelper.initCount += 1;
      },
    });
  }

  public $updateEmailManager(emailManager: EmailManagerModel): Observable<Boolean> {
    // Make a call to save data
    const httpResponse = this.emailManagerService.updateEmailManager(emailManager);

    return httpResponse.pipe(
      map(
        (res: any) => {
          if (res) {
            this.loadInitialData();
            return true;
          }

          return false;
        },
        (err: any) => {
          console.log(err);
          this.alertService.showError('Updating email manager failed!');
          return false;
        },
      ),
    );
  }

  public saveEmailManager(emailManager: EmailManagerModel): void {
    // Make a call to save data
    const httpResponse = this.emailManagerService.saveEmailManager(emailManager);

    httpResponse.subscribe(
      (res: any) => {
        if (res) {
          this.loadInitialData();
        }
      },
      (err: any) => {
        console.log(err);
        this.alertService.showError('Saving email manager failed!');
        return false;
      },
    );
  }

  public $sendEmail(newEmailManager: EmailModelDTO): Observable<any> {
    // Make web api call to add emailManager
    return this.emailManagerService.sendEmail(newEmailManager);
  }
}
